import StatusIndicator from '@cloudscape-design/components/status-indicator';

interface UserRoleBadgeProps {
  role: 'owner' | 'admin' | 'mentor' | 'participant';
  context?: 'program' | 'cohort';
}

export function UserRoleBadge({ role }: UserRoleBadgeProps) {
  const getText = () => {
    if (role === 'owner') return <>You are the <strong>program owner</strong></>;
    if (role === 'admin') return <>You are a <strong>program admin</strong></>;
    if (role === 'mentor') return <>You are a <strong>mentor</strong></>;
    if (role === 'participant') return <>You are <strong>enrolled</strong></>;
    return '';
  };
  return <StatusIndicator type="info">{getText()}</StatusIndicator>;
}
